import * as React from "react";
import '../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import i18n from "i18next";
import "../vodafone.css"
import {Col, Row} from "reactstrap";

class SpacerRow extends React.Component {
    constructor(props){
        super(props);
    }

    render() {
        return <Row className={"padding-top-24"}></Row>;
    }
}

export {SpacerRow}